// extracted by mini-css-extract-plugin
export default {"modal":"components-settings-budget-forecast-modal-bulk-update-module__modal"};